export default __webpack_public_path__ + "static/media/EditIcon.58279ff9.svg";